module.exports = __webpack_public_path__ + "img/kehulogo.71169116.png";